<template>
  <div>
    <section class="mb-5">
      <image-element
        :src="require('@/assets/Projects/lee/000.png')"
        caption="[빤쓰런, 우리의 런은 도망이 아니다] 포스터 전체, 일러스트 버전과 레터링 버전, 594 x 841mm"
      />
      <article>
        <h1>[빤쓰런, 우리의 런은 도망이 아니다]</h1>
        <p class="desc">
          빤쓰런 포스터는 MZ세대의 조기 퇴사를 주제로 제작하였다. 한 구직사이트
          조사 결과, MZ세대의 1년 이내 조기 퇴사자 비율이 높은 이유로 '개인의
          만족이 훨씬 중요한 세대라서' 라는 답변이 최우선으로 꼽은 것으로
          나타났다.
        </p>
        <p class="desc">
          이런 조기퇴사를 끈기가 없는 도망인양 평가하는 부정적인 실태를 표현하기
          위해 인터넷 은어 '빤쓰런'을 사용하여 이런 MZ세대의 조기퇴사가 도망이
          아니고 우리 개인의 만족을 높이고 더 나은 곳으로 나아가기 위한
          발돋음이란 것을 표현하고자 한다.
        </p>
      </article>
    </section>
    <hr />
    <section class="mb-5">
      <image-element
        :src="require('@/assets/Projects/lee/001.png')"
        caption="빤쓰런 포스터, 일러스트 버전, 세로형, 594 x 841mm"
      />
      <p class="desc">
        일러스트 버전의 포스터이다. 앞서 설명한 발돋음을 표현하기 위해 그 열정이
        느껴지는 색상을 사용하였다. 배경은 이에 보색수준으로 대비되면서 하늘을
        연상하는 색상을 사용해 팬티 일러스트가 마치 하늘 높이 들어올린 깃발처럼
        그렸다.
      </p>
      <image-element :src="require('@/assets/Projects/lee/002.png')" />
      <p class="desc">
        동적인 느낌을 더하기 위해 일러스트에 주름들을 모두 흰 선 테두리로
        그렸다. 평면의 일러스트로 느껴지지 않도록 명암도 추가하였으며, 카피 또한
        사선으로 배치하여 동적으로 느껴지게 했다. 정보전달의 목적인 포스터가
        아니었기 때문에 두 줄 정도의 문장으로 된 서브 카피를 더해 마무리했다.
      </p>
    </section>
    <hr />
    <section class="mb-5">
      <image-element
        :src="require('@/assets/Projects/lee/003.png')"
        caption="빤쓰런 포스터, 레터링 버전, 가로형, 594 x 841mm"
      />
      <p class="desc">
        같은 주제를 가지고 일러스트 버전 외에 레터링 버전 포스터도 함께
        제작했다. 일러스트버전과 같은 각도로 기울여, 같은 곳에 위치하여
        세로형으로도 활용 가능하다.
      </p>
    </section>
    <hr />
    <section class="mb-5">
      <image-element
        :src="require('@/assets/Projects/lee/004.png')"
        caption="목업, 뱃지 시리즈"
      />
      <p class="desc">
        주제를 잘 표현할 수 있는 아이템을 생각하되, 아이템을 통해 결속력을 느낄
        수 있어야 한다. 이를 위해 뱃지 시리즈를 제작한다.
      </p>
      <image-element
        :src="require('@/assets/Projects/lee/005.png')"
        caption="목업, 패브릭 포스터"
      />
      <p class="desc">
        일러스트 버전처럼, 깃발이라는 느낌이 들 수 있도록 패브릭 포스터를
        제작한다.
      </p>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
